import { useMemo } from 'react'
import { getImage } from 'gatsby-plugin-image'

const useGatsbyImage = ({ nodes }, imageName) =>
  useMemo(() => {
    const found = nodes.find(({ name, ext }) => `${name}${ext}` === imageName)
    return found && getImage(found)
  }, [nodes, imageName])

export default useGatsbyImage
